// extracted by mini-css-extract-plugin
export default {"scope":"NUL2k","scope--is-open":"cDqT8","label":"aWzNr","scope--is-selected":"i9XWx","icon":"DU-Rb","name":"_2XaWz","subdirectories":"ku-n6"};